import { createFileRoute } from '@tanstack/react-router'
import { AssetLabelsPage } from '../../../../features/service/assets/labels-page'
import { assetLabelsSearchSchema } from '../../../../features/service/assets/search'

/** Sites & assets › Asset labels (the register's crumb comes from the parent route). */
export const Route = createFileRoute('/_app/service/assets/labels')({
  staticData: { crumb: 'serviceAssetLabels' },
  validateSearch: assetLabelsSearchSchema,
  component: AssetLabelsPage,
})
